import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "MailInterleavedSearchExperiment" */ "./lazyIndex"), { name: "MailInterleavedSearchExperiment" });

export const lazyPerformInterleavedSearch: LazyAction<typeof lazyIndex.performInterleavedSearch, typeof lazyModule> = new LazyAction(lazyModule, m => m.performInterleavedSearch);
